import * as React from 'react';
import type { SVGProps } from 'react';

interface Props extends SVGProps<SVGSVGElement> {
  size?: number;
}

const SvgNeutral = (props: Props) => {
  const { size = 24, ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      {...svgProps}
    >
      <path
        d="M25.3295 22.2153C25.3295 22.9502 25.0376 23.6549 24.518 24.1746C23.9983 24.6942 23.2936 24.9861 22.5587 24.9861C21.8238 24.9861 21.119 24.6942 20.5994 24.1746C20.0798 23.6549 19.7879 22.9502 19.7879 22.2153C19.7879 21.4804 20.0798 20.7757 20.5994 20.256C21.119 19.7364 21.8238 19.4445 22.5587 19.4445C23.2936 19.4445 23.9983 19.7364 24.518 20.256C25.0376 20.7757 25.3295 21.4804 25.3295 22.2153ZM35.4892 19.4445C34.7544 19.4445 34.0496 19.7364 33.53 20.256C33.0103 20.7757 32.7184 21.4804 32.7184 22.2153C32.7184 22.9502 33.0103 23.6549 33.53 24.1746C34.0496 24.6942 34.7544 24.9861 35.4892 24.9861C36.2241 24.9861 36.9289 24.6942 37.4485 24.1746C37.9682 23.6549 38.2601 22.9502 38.2601 22.2153C38.2601 21.4804 37.9682 20.7757 37.4485 20.256C36.9289 19.7364 36.2241 19.4445 35.4892 19.4445ZM51.1906 26.8334C51.1843 32.7104 48.8468 38.3449 44.6912 42.5005C40.5355 46.6562 34.901 48.9937 29.024 49C-0.346865 47.8917 -0.335783 5.77502 29.024 4.66669C34.901 4.67304 40.5355 7.01049 44.6912 11.1662C48.8468 15.3219 51.1843 20.9563 51.1906 26.8334ZM47.4962 26.8334C47.4908 21.9359 45.5429 17.2405 42.0799 13.7775C38.6168 10.3144 33.9215 8.36651 29.024 8.36113C4.55197 9.28474 4.55936 44.382 29.024 45.3056C33.9215 45.3002 38.6168 43.3523 42.0799 39.8892C45.5429 36.4262 47.4908 31.7308 47.4962 26.8334Z"
        fill="#A5A5AA"
      />
    </svg>
  );
};

export default SvgNeutral;
